import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router'
import { PersistGate } from 'redux-persist/integration/react'
import { ConfigProvider } from 'antd'
import enUSIntl from 'antd/lib/locale/en_US'

import App from './App'
import reportWebVitals from './reportWebVitals'
import { store, history, persistor } from './app/store'

const loader = document.querySelector('.loader')

// if you want to show the loader when React loads data again
const showLoader = () => loader.classList.remove('loader--hide')

const hideLoader = () => loader.classList.add('loader--hide')

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <ConnectedRouter history={history}>
        <ConfigProvider locale={enUSIntl}>
          <App hideLoader={hideLoader} showLoader={showLoader} />
        </ConfigProvider>
      </ConnectedRouter>
    </PersistGate>
  </Provider>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
